import React, {useEffect} from 'react';
import Breadcrumbs from "../ui/Breadcrumbs";
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {ProgramFilter} from './components/ProgramFilter';
import {ProgramList} from './components/ProgramFilter';
import './styles/app.scss';

const items = [
  {
    label: "Каталог образовательных программ",
    link: "#"
  },
];

const Catalog = () => {
  return (
    <div>
      <Breadcrumbs items={items} />
      <div>
        <ProgramFilter/>
        <div className="block-margin"/>
      </div>
    </div>
  );
};

export default Catalog;
